import { getApiUrl } from "Infrastructure/Api/Api";
import { useVerticalListQuery } from "Settings/Modules/OrderSetup/Api/Query/useVerticalListQuery";
import { selectedVerticalsAtom } from "Shared/Atoms/verticalAtom";
import {
	Box,
	Checkbox,
	ListItemText,
	MenuItem,
	Select,
	type SelectChangeEvent,
} from "@mui/material";
import { useAtom } from "jotai";

export function VerticalSelector() {
	const { data: verticals, error, isLoading } = useVerticalListQuery();
	const [selectedVerticals, setSelectedVerticals] = useAtom(
		selectedVerticalsAtom,
	);

	const handleChange = (event: SelectChangeEvent<unknown[]>) => {
		const value = event.target.value;

		if (Array.isArray(value) && value.includes("all")) {
			const allVerticalIds: number[] = verticals?.map((v) => v.id) || [];
			// If all items are already selected, deselect all
			if (selectedVerticals.length === allVerticalIds.length) {
				setSelectedVerticals([]);
			} else {
				// Select all items
				setSelectedVerticals(allVerticalIds);
			}
		} else {
			setSelectedVerticals(
				Array.isArray(value) ? value.map(Number) : [Number(value)],
			);
		}
	};

	if (isLoading) {
		return <div>Loading verticals...</div>;
	}

	if (error) {
		return <div>Error loading verticals</div>;
	}

	return (
		<Select
			id="global-verticals"
			name="global-verticals"
			multiple
			value={selectedVerticals}
			onChange={handleChange}
			fullWidth
			renderValue={(s: number[]) => {
				return s.map((id) => verticals?.find((v) => v.id === id)?.name).length;
			}}
		>
			<MenuItem key="select-all" value="all" dense divider sx={{ py: 0 }}>
				<Checkbox
					checked={
						selectedVerticals.length === verticals?.length &&
						verticals?.length > 0
					}
				/>
				<ListItemText primary="Select All" />
			</MenuItem>
			{verticals?.map((vertical) => (
				<MenuItem
					key={vertical.id}
					value={vertical.id}
					dense
					divider
					sx={{ py: 0 }}
				>
					<Checkbox checked={selectedVerticals.includes(vertical.id)} />
					<Box mr={1}>
						<img
							src={`${getApiUrl()}${vertical.iconPath}`}
							alt={`${vertical.name} icon`}
							width="20px"
							height="20px"
						/>
					</Box>
					<ListItemText
						primary={vertical.name}
						sx={{ textTransform: "capitalize" }}
					/>
				</MenuItem>
			))}
		</Select>
	);
}
